import React from "react";
import { Container, Typography, Box, Paper, Divider } from "@mui/material";

export default function TermsOfService() {
  return (
    <Box sx={{ py: 8, bgcolor: "#f5f7fa" }}>
      <Container maxWidth="md">
        <Paper elevation={2} sx={{ p: { xs: 4, md: 6 }, borderRadius: 3 }}>
          <Typography variant="h3" fontWeight={700} color="primary" gutterBottom>
            Terms of Service
          </Typography>
          <Typography variant="subtitle1" color="text.secondary" paragraph>
            Last Updated: {new Date().toLocaleDateString()}
          </Typography>
          <Divider sx={{ mb: 4 }} />

          <Typography variant="h5" fontWeight={600} gutterBottom sx={{ mt: 4 }}>
            General
          </Typography>
          <Typography variant="body1" paragraph>
            Review these Terms of Service ("Agreement") thoroughly. This Agreement is a legal agreement between the User and Rite Account. By accepting electronically (for example, clicking “I Agree”), installing, accessing or using the Services, User agrees to these terms. If the User does not agree to this Agreement, then he/she may not use the Services. This License Agreement shall be governed by and construed in accordance with the laws of the INDIA.
          </Typography>

          <Typography variant="h5" fontWeight={600} gutterBottom sx={{ mt: 4 }}>
            Modification of terms & conditions
          </Typography>
          <Typography variant="body1" paragraph>
            These terms may be updated from time to time in the future. The User should agree to review our Terms and Conditions regularly by visiting this page. Continued access to or use of the service will mean that the User agrees to the change.
          </Typography>

          <Typography variant="h5" fontWeight={600} gutterBottom sx={{ mt: 4 }}>
            Terms and Description of Services
          </Typography>
          <Typography variant="body1" paragraph>
            We provide an array of services including Inventory management, Invoicing, Reporting tool, Estimate/Order Form creator and so on to serve as a complete business management software ("Service" or "Services"). The User may use the Services for his/her personal and business use or for internal business purpose in the organization that he/she represent. The User may download the application from the Official website/ Google Play Store using the Internet. Once downloaded, the User no longer needs an internet connection for its usage. A User can create and add content to his/her account staying offline. But, the User is responsible for obtaining access to the Internet and the device necessary to use the Services.<br/><br/>
            <em>(Side Note: Rite Account tries its best to make Businesses compliant to taxation and other laws as much as possible. But, it is solely the User’s responsibility to see that he/she remains compliant with GST and other laws levied by Government. Rite Account is not in any case responsible for the violation of the compliance caused by software)</em><br/><br/>
            For the software subscription services purchased on Rite Account, the validity of the license period shall commence on or before 60 days since the date of purchase. Rite Account reserves all rights to increase or reduce this grace period.
          </Typography>

          <Typography variant="h5" fontWeight={600} gutterBottom sx={{ mt: 4 }}>
            Data Ownership
          </Typography>
          <Typography variant="body1" paragraph>
            The User owns the content created or stored by his/her as we respect his/her right to ownership of content created or stored by them. The Users use of the Services does grant Rite Account the license to use, reproduce, adapt, modify, publish or distribute the content created by them or stored in the user’s account for Rite Account internal purpose. Rite Account tries keeping Users data safe but holds zero responsibility in case of data leaks.
          </Typography>

          <Typography variant="h5" fontWeight={600} gutterBottom sx={{ mt: 4 }}>
            Approval of Alerts, Messages and Promotional campaign
          </Typography>
          <Typography variant="body1" paragraph>
            In addition to the General Conditions of Rite Account service a User agrees to be bound by the following terms and conditions:<br/>
            (i) The User agrees to receive promotional, transactional and commercial communications from Rite Account through calls, email, SMS or push notifications.<br/>
            (ii) Under certain conditions, promotional messages are transmitted to the users and that Rite Account shall not bear any further obligation in respect of such promotional messages.
          </Typography>

          <Typography variant="h5" fontWeight={600} gutterBottom sx={{ mt: 4 }}>
            Refund, Cancellation, and Renewal Policies
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>1. Eligibility for Full Refund:</strong> Customers who submit a refund request via email or through our website within 7 days from the date of purchase will be eligible for a 100% refund.<br/>
            <strong>2. Method for Requesting Refunds:</strong> To initiate a refund, please submit your request through email or via our website.<br/>
            <strong>3. Other Refund Policies for Purchases:</strong> Our refund policy applies exclusively to purchases with a duration of one year or longer.<br/>
            <strong>4. Non-Refundable Convenience Fees:</strong> Please note that convenience fees are non-refundable in the event of a license cancellation.<br/>
            <strong>5. Manual Renewal Process:</strong> Our system does not automatically renew licenses. For continued service, customers are required to manually renew their license at the end of their validity.
          </Typography>

          <Typography variant="h5" fontWeight={600} gutterBottom sx={{ mt: 4 }}>
            Contact Us
          </Typography>
          <Typography variant="body1" paragraph>
            If you have any questions or concerns regarding this Agreement, please contact us at support@riteaccount.com
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
}
